export default value => {
  return options[value] || "N";
};

const options = {
  yes: "Y",
  no: "N",
  true: "Y",
  false: "N"
};